import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
const CUPOS_PERCENT = 68;
export function CountdownBanner() {
  const [timeLeft, setTimeLeft] = useState<number | null>(null);
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    const DURATION = 24 * 60 * 60 * 1000; // 24 hours
    const storedStartTime = localStorage.getItem('promoStartTime');
    let startTime: number;
    if (storedStartTime) {
      startTime = parseInt(storedStartTime, 10);
    } else {
      startTime = Date.now();
      localStorage.setItem('promoStartTime', startTime.toString());
    }
    const calculateTimeLeft = () => {
      const remaining = DURATION - (Date.now() - startTime);
      if (remaining <= 0) {
        setIsExpired(true);
        setTimeLeft(0);
      } else {
        setTimeLeft(remaining);
      }
    };
    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(interval);
  }, []);
  if (timeLeft === null) return null;
  const hours = Math.floor(timeLeft / 3600000);
  const minutes = Math.floor(timeLeft % 3600000 / 60000);
  const seconds = Math.floor(timeLeft % 60000 / 1000);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5
  }} className="bg-gray-950 text-white py-10 px-4" data-id="element-55">
      <div className="max-w-xl mx-auto text-center" data-id="element-56">
        {/* Header */}
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-57">
          <Clock className="w-5 h-5 text-brand-400" data-id="element-58" />
          <span className="text-sm sm:text-base font-bold tracking-wide uppercase text-gray-300" data-id="element-59">
            El precio de lanzamiento termina en:
          </span>
        </div>

        {/* Timer */}
        {!isExpired ? <div className="flex items-center justify-center gap-3 sm:gap-5 mb-5" data-id="element-60">
            <TimeUnit value={hours} label="hs" data-id="element-61" />
            <span className="text-3xl font-bold text-gray-500 -mt-5" data-id="element-62">:</span>
            <TimeUnit value={minutes} label="min" data-id="element-63" />
            <span className="text-3xl font-bold text-gray-500 -mt-5" data-id="element-64">:</span>
            <TimeUnit value={seconds} label="seg" data-id="element-65" />
          </div> : <div className="text-2xl font-heading font-bold text-gray-500 mb-5" data-id="element-66">
            PROMO FINALIZADA
          </div>}

        {/* Subtext */}
        <p className="text-gray-400 text-sm sm:text-base mb-8" data-id="element-67">
          Después sube <span className="text-white font-bold" data-id="element-68">$12.000 ARS</span>{' '}
          y no vuelve a bajar.
        </p>

        {/* Cupos progress */}
        <div className="bg-gray-900 border border-gray-800 rounded-2xl p-5" data-id="element-69">
          <div className="flex items-center justify-between mb-3" data-id="element-70">
            <div className="flex items-center gap-2" data-id="element-71">
              <span className="relative flex h-2.5 w-2.5" data-id="element-72">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-73" />
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" data-id="element-74" />
              </span>
              <span className="text-sm font-semibold text-gray-300" data-id="element-75">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs font-bold text-brand-400 bg-brand-500/15 px-2 py-0.5 rounded-full" data-id="element-76">
              Quedan pocos
            </span>
          </div>

          {/* Progress bar */}
          <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden" data-id="element-77">
            <motion.div className="h-full rounded-full bg-gradient-to-r from-brand-500 to-brand-400" initial={{
            width: 0
          }} whileInView={{
            width: `${CUPOS_PERCENT}%`
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.2,
            ease: 'easeOut',
            delay: 0.3
          }} data-id="element-78" />
          </div>
          <p className="text-xs text-gray-500 mt-2 text-right" data-id="element-79">
            {CUPOS_PERCENT}% de los cupos tomados
          </p>
        </div>
      </div>
    </motion.div>;
}
function TimeUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-80">
      <motion.span key={value} initial={{
      y: -4,
      opacity: 0.5
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      duration: 0.25
    }} className="font-mono font-extrabold text-4xl sm:text-5xl tabular-nums text-white leading-none" data-id="element-81">
        {value.toString().padStart(2, '0')}
      </motion.span>
      <span className="text-[11px] font-semibold text-gray-500 uppercase tracking-widest mt-1" data-id="element-82">
        {label}
      </span>
    </div>;
}